module.exports = __webpack_public_path__ + "static/media/LV4@2x.44bff83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV4@2x.png
// module id = 683
// module chunks = 0